import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-thick",
  "use": "plus-thick-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"plus-thick\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8 1a1 1 0 00-1 1v5H2a1 1 0 000 2h5v5a1 1 0 102 0V9h5a1 1 0 100-2H9V2a1 1 0 00-1-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol